import filter from 'lodash/filter';
import head from 'lodash/head';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import size from 'lodash/size';
import templateUrl from './editor-video-link-modal.html';

export const editorVideoLinkModalComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl,

    controller: class EditorVideoLinkModalComponent {
        constructor($sce, EditorService, ModalService, ApiService, toastr) {
            'ngInject';

            this.$sce = $sce;
            this.editorService = EditorService;
            this.modalService = ModalService;
            this.apiService = ApiService;
            this.toastr = toastr;
        }

        $onInit() {
            this.contentId = this.resolve.details.data.id;
            this.disableButtons = true;
            this.selectedLink = "";
            this.videos = this._getVideos();
            this.tabOptions = [{
                id: 1,
                name: 'upload video',
                isSelected: true
            },{
                id: 2,
                name: 'video library',
                isSelected: false
            }];
            this.isEditOptionEnabled = false;
            this.showUploadedVideo = false;
            this.deletedVideos = [];
            this.selectedTab = head(filter(this.tabOptions, (tabOption) => tabOption.isSelected));
        }

        onChangeTab(tab) {
            const previousSelectedTab = head(filter(this.tabOptions, (tabOption) => tabOption.isSelected)); 
            this.selectedTab = head(filter(this.tabOptions, ({id}) => id === tab.id));
            previousSelectedTab.isSelected = false;
            this.selectedTab.isSelected = true;
            this.selectedLink = "";
            this.disableButtons = true;
            this.isEditOptionEnabled = false;
            this.showUploadedVideo = false;
            this.invalidVideoLink = false;
            this.deletedVideos = [];
            this.videos = this._getVideos();
        }

        onChangeEdit() {
            this.disableButtons = true;
            this.isEditOptionEnabled = !this.isEditOptionEnabled;
            this.videos = this._getVideos();
        }

        onInsertVideo() {
            if(this._isGivenLinkValid()) {
                this.disableButtons = false;
                this.showUploadedVideo = true;
                this.invalidVideoLink = false;
                this.videos.unshift({link:this.selectedLink});
                this.resolve.details.getAllUpdatedContentVideos(this._setVideos(this.videos));
                this.onSubmit();
            } else {
                this.invalidVideoLink = true;
            }
        }

        onSelectLink(selectedLink) {
            if(!this.isEditOptionEnabled) {
                this.disableButtons = false;
                this.selectedLink = selectedLink;
            } else {
                this._setDeleteingVideos(selectedLink);
                this.disableButtons = size(this.deletedVideos) > 0 ? false : true;
            }
        }

        onDeleteVideo() {
            this.deletedVideos = this._getDeletedVideos();
            this.videos = this._getNonDeletedVideos();
            this.resolve.details.getDeletedLinks(this.deletedVideos);
            this.resolve.details.getAllUpdatedContentVideos(this._setVideos(this.videos));
            const successMessage = size(this.deletedVideos) > 0 ? `links are deleted successfully.` : `link is deleted successfully.`;
            this.toastr.success(successMessage);
            this.close();
        }

        onCancel() {
            this.selectedLink = "";
            this.disableButtons = true;
            this.isEditOptionEnabled ? this.onChangeEdit() : this.close();
        }

        onSubmit() {
            this.resolve.details.getSelectedLink(this.selectedLink);
            this.close();
        }

        //--------------------------------------------------------------------PRIVATE METHODS------------------------------------------------

        _isGivenLinkValid() {
            if(this._isGivenLinkFromYoutube()) {
                this.selectedLink = this._getModifiedYoutubeLink();
            }

            if(this._isGivenLinkFromVimeo()) {
                this.selectedLink = this._getModifiedVimeoLink();
            }

            if(!this._checkIsLinkAlreadyAvailable()) {
                return true;
            }

            return false;
        }

        _checkIsLinkAlreadyAvailable() {
            return findIndex(this.videos, ({link}) => link === this.selectedLink) !== -1 ? true : false; 
        }

        _isGivenLinkFromYoutube() {
            return this.selectedLink.indexOf("https://www.youtube.com/watch?v") === -1 ? false : true;
        }

        _getModifiedYoutubeLink() {
            return this.selectedLink.replace('watch?v=','embed/');
        }

        _isGivenLinkFromVimeo() {
            return this.selectedLink.indexOf("vimeo.com") === -1 ? false : true;
        }

        _getModifiedVimeoLink() {
            const lastIndex = this.selectedLink.lastIndexOf('/');
            const vimeoVideoId = this.selectedLink.slice(lastIndex);
            return `https://player.vimeo.com/video${vimeoVideoId}`;
        }

        _setDeleteingVideos(selectedLink) {
            const selectedVideo = find(this.videos,({link}) => link === selectedLink);
            selectedVideo.isSelected = !selectedVideo.isSelected;
            this.deletedVideos = this._getDeletedVideos();
        }

        _getVideos() {
            return this.resolve.details.data.videos.map(({link}) =>({link,isSelected:false}));
        }

        _setVideos(videos) {
            return videos.map(({link}) =>({link}));
        }

        _getDeletedVideos() {
            return filter(this.videos,({isSelected}) => isSelected);
        }

        _getNonDeletedVideos() {
            return filter(this.videos,({isSelected}) => !isSelected);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/editor/editor-video-link-modal/editor-video-link-modal.component.js